export default "__VITE_ASSET__BbcIpjhj__"